import { parseIngredient, RecipeDraft, timerOf } from '../recipes';
import { IDEAS_1 } from './part1';
import { IDEAS_2 } from './part2';
import { IDEAS_3 } from './part3';
import { IDEAS_4 } from './part4';
import { IDEAS_5 } from './part5';
import type { IdeaSource } from './types';

export type { IdeaSource, IdeaText } from './types';
export { IDEA_PHOTOS, ideaPhotoUrl, type IdeaPhoto } from './photos';

/**
 * Larovi-Ideenbuch (Küche 4, 1.22): 50 family classics written for Larovi, German and English
 * (Mike, 14.10.: "Larovi-Ideenbuch … brauche ich deine Kreativität"). They show up as
 * suggestions, can be cooked straight away and copied into the family's own recipes.
 */
export const IDEAS: IdeaSource[] = [...IDEAS_1, ...IDEAS_2, ...IDEAS_3, ...IDEAS_4, ...IDEAS_5];

/** Ideas live under this id prefix wherever a recipe id is expected (plan, recipe page). */
export const IDEA_PREFIX = 'idee-';
export const ideaRecipeId = (ideaId: string) => IDEA_PREFIX + ideaId;
export const isIdeaRecipeId = (id: string | null | undefined): id is string =>
  !!id && id.startsWith(IDEA_PREFIX);
export const ideaOf = (recipeId: string) =>
  IDEAS.find((i) => IDEA_PREFIX + i.id === recipeId) ?? null;

/** An idea in the recipe shape, in the app's language. */
export function ideaDraft(idea: IdeaSource, locale: 'de' | 'en'): RecipeDraft {
  const t = idea[locale];
  return RecipeDraft.parse({
    title: t.title,
    servings: 4,
    minutes: idea.minutes,
    ingredients: t.ingredients.map(parseIngredient),
    steps: t.steps.map((text) => ({ text, minutes: timerOf(text) })),
    tags: idea.tags,
    kidsTip: t.kidsTip,
    // the id travels in the note, so a copied idea is not suggested again as "new"
    source: { kind: 'idea', url: null, note: idea.id },
  });
}
